module.exports = __webpack_public_path__ + "static/media/rent.a23aa455.pdf";